var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidrIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.514,
    height: 42.916,
    viewBox: "0 0 19.514 42.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hidr-icon",
    transform: "translate(0.28 0.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "body",
    d: "M138.427,67.5a.989.989,0,0,1,.986.989v38.7a.989.989,0,0,1-.986.989H122.589a.989.989,0,0,1-.989-.989V68.49a.989.989,0,0,1,.989-.989h15.838m0-.6H122.589A1.587,1.587,0,0,0,121,68.49v39.238a1.587,1.587,0,0,0,1.589,1.588h15.838a1.588,1.588,0,0,0,1.588-1.588V68.49a1.588,1.588,0,0,0-1.588-1.588Z",
    transform: "translate(-121.03 -66.94)",
    fill: "#fbfbfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_-_Outline",
    "data-name": "body - Outline",
    d: "M122.587,66.65h0l15.841,0a1.838,1.838,0,0,1,1.836,1.838v39.238a1.838,1.838,0,0,1-1.838,1.838H122.589a1.837,1.837,0,0,1-1.839-1.838V68.49a1.849,1.849,0,0,1,.538-1.3A1.825,1.825,0,0,1,122.587,66.65Zm15.838.5H122.587a1.328,1.328,0,0,0-.946.392,1.346,1.346,0,0,0-.391.948v39.238a1.337,1.337,0,0,0,1.337,1.338h15.84a1.338,1.338,0,0,0,1.338-1.338V68.49a1.338,1.338,0,0,0-1.338-1.338Zm-15.836.1h15.838a1.245,1.245,0,0,1,1.236,1.241v38.7a1.241,1.241,0,0,1-1.236,1.239H122.589a1.24,1.24,0,0,1-1.239-1.239V68.49A1.24,1.24,0,0,1,122.589,67.252Zm15.837,40.678a.74.74,0,0,0,.737-.739v-38.7a.743.743,0,0,0-.738-.741H122.589a.739.739,0,0,0-.739.739v38.7a.739.739,0,0,0,.739.739Z",
    transform: "translate(-121.03 -66.94)",
    fill: "#fbfbfd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "camera",
    cx: 1.014,
    cy: 1.014,
    r: 1.014,
    transform: "translate(8.464 2.155)",
    fill: "#fbfbfd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "square-menu",
    transform: "translate(-0.337)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19430",
    "data-name": "Rectangle 19430",
    width: 0.912,
    height: 0.912,
    transform: "translate(4.555 39)",
    fill: "#fbfbfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75153",
    "data-name": "Path 75153",
    d: "M212.35,861v1.158h-1.158V861h1.158m0,0h-1.16v1.161h1.161V861Z",
    transform: "translate(-206.762 -822.123)",
    fill: "#fbfbfd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle-menu",
    transform: "translate(0.212)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1933",
    "data-name": "Ellipse 1933",
    cx: 0.468,
    cy: 0.468,
    rx: 0.468,
    ry: 0.468,
    transform: "translate(9.013 38.973)",
    fill: "#fbfbfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75154",
    "data-name": "Path 75154",
    d: "M306.24,861a.6.6,0,1,1-.6.6.6.6,0,0,1,.6-.6m0,0a.6.6,0,1,0,.6.6A.6.6,0,0,0,306.24,861Z",
    transform: "translate(-296.761 -822.158)",
    fill: "#fbfbfd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "triangle-menu",
    transform: "translate(0.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75155",
    "data-name": "Path 75155",
    d: "M280.74,796.247l.672-.4v.794Z",
    transform: "translate(-266.859 -756.725)",
    fill: "#fbfbfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75156",
    "data-name": "Path 75156",
    d: "M399.971,860.282v1.1l-.927-.548.927-.548m0,0-.931.548.931.548v-1.1Z",
    transform: "translate(-385.325 -821.307)",
    fill: "#fbfbfd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidrIcon);
export default __webpack_public_path__ + "static/media/hidr-icon.2a54362ead248420f0b9c713ec0a0b5a.svg";
export { ForwardRef as ReactComponent };